import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors } from "@clockwise/web-commons/src/styles/color.styles";
import { baseBody } from "../SuggestionBody.styles";

export const container: CSSProperties = {
  ...baseBody,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
};

export const plus: CSSProperties = {
  color: colors.blueDusk.standard,
  fontSize: 36,
  padding: `0 10px`,
};
